/**
 * Kalshi price helpers
 *
 * Many Kalshi endpoints represent prices as either:
 * - probability in dollars (0.00 - 1.00), or
 * - integer cents (0 - 100).
 *
 * Internally in this app we treat prices as probability (0.00 - 1.00).
 *
 * @ai-context
 *   Role: Heuristic normalizer for ambiguous Kalshi API price units.
 *   Pattern: Single pure function. Detects cents vs probability by threshold.
 *
 * @ai-invariant Threshold is 1.01: values > 1.01 are assumed cents and
 *   divided by 100. Values <= 1.01 pass through as probability.
 *   Edge case: a price of exactly 1.0 (100 cents) is treated as probability.
 */

export function normalizeKalshiPriceToProbability(raw: number | null | undefined): number | null {
  if (raw === null || raw === undefined) return null;
  if (!Number.isFinite(raw)) return null;

  // Heuristic: if it looks like cents, convert to probability.
  // (Valid probability is <= 1.0; valid cents are typically 0..100.)
  if (raw > 1.01) return raw / 100;
  return raw;
}
